module.exports = __webpack_public_path__ + "img/mail.500d5aa1.svg";